export default __webpack_public_path__ + "static/media/MacInfo.fad629ed.png";